import React, { memo, useEffect, useState} from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { decode } from 'qss';
import { converter } from './converter';
import { Layout, getModel } from '../components';
import './App.scss';
import { Query } from './Query';
import user_guide from "../utils/user_guide";

const query: Query = decode(window.location.search.substr(1));
query.model = getModel(query.model || 'xiaomi.watch.mars');

const contentTransform = (content: string): string => {
  return converter(content, query);
};

function Detail(props: any) {
  const [source, setSource] = useState("")
  const [fallback, setFallback] = useState<Array<string>>([])
  const params = props.match.params;
  const path = [params.p1, params.p2, params.p3].filter(Boolean).join('/')
  const subPath = path || 'index.md';

  useEffect(()=>{
    void async function(){
      setFallback([])
      const {source, fallback} = await user_guide.getSource(subPath)
      setSource(source)
      setFallback(fallback)
    }()
  }, [subPath])

  if (!fallback.length) {
    return null
  }
  console.log(fallback)
  return (
    <Layout {...{source, contentTransform, fallback}} placeholder={`【${query.model}】 coming soon!`} />
  )
}
const App: React.FC = memo(() => {
  return (
    <Router>
      <Route path="/:p1?/:p2?/:p3?" component={Detail} />
    </Router>
  );
});

export default App;
